module.exports = __webpack_public_path__ + "img/banner.d06083e4.png";